import { UserDetailsCardProvider } from "@sg-protect/components";
import { FeatureFlagKeys } from "@sg-protect/federation-runtime";
import { useFeatureFlag } from "@sg-protect/federation-runtime/squide";
import type { PropsWithChildren } from "react";
import { renderUserIdentityCard } from "../user-details/UserDetailsCard.tsx";

export function FlaggedUserDetailsCardProvider({ children }: PropsWithChildren) {
    const isUserDetailsCardReleased = useFeatureFlag(FeatureFlagKeys.UserDetailsCardReleased, false);

    if (!isUserDetailsCardReleased) {
        return children;
    }

    return <UserDetailsCardProvider renderUserDetailsCard={renderUserIdentityCard}>{children}</UserDetailsCardProvider>;
}
